@for (icon of availableIcons; track icon) {
  <span class="bg-white rounded-md m-2 inline-block w-[10rem] text-center p-2">
    <mat-icon [customMatSvgIcon]="icon" />
    <div class="text-[x-small] text-gray-400">{{ icon }}</div>
  </span>
}
